// src/pages/Shipping.jsx
import React from "react";

// קומפוננטת עמוד "מדיניות משלוחים"
export default function Shipping() {
  const lastUpdated = new Date().toLocaleDateString("he-IL");

  return (
    <main dir="rtl" lang="he" className="nfig-legal my-10 space-y-6">
      <header className="space-y-1">
        <h1 className="text-3xl font-bold">מדיניות משלוחים</h1>
        <p className="text-sm text-gray-500">תאריך עדכון אחרון: {lastUpdated}</p>
      </header>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">1. זמני אספקה</h2>
        <p>
          אנו משתדלים לספק את ההזמנה תוך <strong>7-10 ימי עסקים</strong> מרגע
          אישור העסקה ותשלום מלא. ייתכנו עיכובים באזורים מרוחקים או בתקופות
          עומס.
        </p>
        <p>
        מוצרים בהזמנה מוקדמת (“Pre-Order”) יסופקו בתוך 30–40 ימים ממועד ההזמנה,
        בכפוף לאי־עיכובים מצד הספק או חברת המשלוחים. במקרה של עיכוב חריג, תישלח אליך
        הודעה מראש.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">2. אזורי שירות</h2>
        <p>
          אנו מבצעים משלוחים לכל רחבי ישראל. ייתכנו חריגות/הגבלות אספקה באזורים
          מסוימים (כגון יישובים מעבר לקו הירוק או אזורים מרוחקים).
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">3. עלויות משלוח</h2>
        <ul className="list-disc pr-5 space-y-1">
          <li>דמי משלוח סטנדרטיים: <strong>[₪]</strong>.</li>
         {/*} <li>משלוח חינם בקנייה מעל <strong>[₪ סכום מינימום]</strong>.</li>*/}
          <li>משלוח אקספרס (1–2 ימי עסקים): <strong>[₪]</strong>.</li>
        </ul>
        <p>דמי המשלוח יוצגו בבירור לפני ביצוע התשלום בקופה.</p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">4. שיטות שילוח</h2>
        <p>
          המשלוחים מבוצעים באמצעות חברות שליחויות חיצוניות (כגון דואר ישראל,
          צ׳יטה, UPS וכו׳). ברוב המקרים תישלח הודעת SMS עם מספר מעקב.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">5. אחריות ואובדן</h2>
        <p>
          מרגע מסירת החבילה לחברת המשלוחים, האחריות לאובדן/עיכוב חלה על חברת
          השילוח. אנו כמובן נלווה את התהליך מול החברה עד למציאת פתרון.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">6. יצירת קשר</h2>
        <address className="not-italic">
          לכל שאלה או בירור בנוגע למשלוחים:{" "}
          <a
            className="text-blue-700 underline"
            href="mailto:example@yourshop.com"
          >
            example@yourshop.com
          </a>{" "}
          | טל׳: <strong>[מספר]</strong>
        </address>
      </section>
    </main>
  );
}
